// extracted by mini-css-extract-plugin
export default {"form":"styles_form__jBxFq","headerText":"styles_headerText__l3DjX","inputs":"styles_inputs__BDWAO","textarea":"styles_textarea__JPeQV","input":"styles_input__wz2J3"};